<template>
  <div class="config-detail-box">
    <div class="config-detail">
      <div  v-for="(item,index) of subAssignList" :key="item.diaplayName" ref="editFormRef">
        <div class="assign-item">
          <div class="assign-region-title">{{getName(item.diaplayName)}}(当前配额：{{subAssignListInfo[index].assignQty}} {{ units }} )</div>
          <el-input type="number" :min="item.totalCountQty" class="item" v-model="item.assignQty" placeholder="请输入分配额度" @change="(...val) => updateSubmitData(index,item.submitCountQty,item.totalCountQty,...val)" ></el-input>
          <div v-if="isBU" class="assign-region-info">已提报：{{(item.submitCountQty||0)}}</div>
          <div v-if="isHQ" class="assign-region-info">已分配：{{item.totalCountQty}}</div>
        </div>
      </div>
    </div>
    <!-- <div class="tip" v-else>暂无可修改数据！</div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props:{
    // assignList: { type: Object, default: () => {} },
    assignItemInfo: { type: Object, default: () => { } },
    getSubAssignList: { type: Array, default: () => [] },
    //assignList:{ type: Array, default: () => [] },
    assignBuList:{ type: Array, default: () => [] },
    assignRegionList: { type: Array, default: () => [] },
    assignAreaList: { type: Array, default: () => [] },
    srcAssignId:{type:String,default:'0'},
    itemKey:{type:Number,default:1},
    subAssignListInfo:{ type: Array, default: () => [] },
    units:{type:String,default:'场'},
  },
  computed: {
    ...mapGetters(['userInfo']),
    isHQ(){
      return this.employeeLevel>=90
    },
    isBU(){
      return this.employeeLevel>=60&&this.employeeLevel<90
    },
    isRegion(){
      return this.employeeLevel>=45&&this.employeeLevel<60
    },
  },
  data(){
    return {
      employeeLevel:'',
      assignQty:'',
      subAssignItem:{
        assignQty:''
      },
      value1:[],
      assignName:'',
      editRules:{
        // assignQty:[{ required: true, message: "请输入分配额度", trigger: "blur" }]
      },
      subAssignList:[],
      ischangeDate:false,
      noData:true
    }
  },
  created(){
    this.employeeLevel = this.userInfo.employeeLevel
    this.subAssignList = this.subAssignListInfo.map(item=>{
      if(item.assignStatus==100){
        this.noData=false
      }
      let data = {
        //orgName:item.orgName,
        itemKey:this.itemKey,
        assignQty:item.assignQty,
        submitCountQty:item.submitCountQty,
        assignStartTime:item.assignStartTime,
        assignEndTime:item.assignEndTime,
        assignStatus:item.assignStatus,
        totalCountQty:item.totalCountQty
        //orgCode:item.orgCode,
      }
      if(this.isHQ){
        data.buCode = item.buCode
        data.diaplayName = item.buName
      }else if(this.isBU){
        data.regionCode = item.regionCode
        data.diaplayName = item.regionName
      }else if(this.isRegion){
        data.areaCode = item.orgCode
      }
      return data
    })
  },
  mounted(){
    //console.log(this.subAssignList);
    this.$emit("handleSubmitAssign",this.subAssignList,this.itemKey)
  },
  methods:{
    // getResult(){
    //   let assignQty = 0
    //   if(this.isBU){
    //     assignQty = subAssignListInfo.assignQty
    //   }
    //   //let assignQty = this.curAssignInfo[assignItemKey].assignQty
    //   let result = 0
    //   result = this.subAssignList.reduce((pre,cur)=>{
    //     return pre+Number(cur.assignQty)
    //   },0)
    //   if((assignQty-result)<0){
    //     this.showError1 = true
    //   }
    //   console.log();
    //   //let data = assignQty - result
    //  // console.log(data);
    //   //((assignQty-result)<0)?this.isError = true:''
    //   return (assignQty - result)
    // },
    showChangeDate(){
      this.ischangeDate = true
    },
    handleDelete(){
      this.$emit("handleDeleteAssign",this.itemKey)
    },
    getName(str){
      if(str){
          return str.split('|')[0] || str
      }else return ''
    },
    submit(){
      if(this.employeeLevel>=90){
        this.subAssignItem.buCode = this.assignItem.orgCode
        this.subAssignItem.srcAssignId = '0'
        this.subAssignItem.buChangeQty = this.subAssignItem.assignQty
        this.subAssignItem.itemKey = this.itemKey
      }else if(this.employeeLevel>=60&&this.employeeLevel<=90){
        if(this.buToCity==1){
          this.subAssignItem.areaCode = this.assignItem.orgCode
          this.subAssignItem.regionCode = this.assignItem.parentOrgCode
          this.subAssignItem.srcAssignId = this.srcAssignId
        }else {
          this.subAssignItem.regionCode = this.assignItem.orgCode
          this.subAssignItem.srcAssignId = this.srcAssignId
          this.subAssignItem.itemKey = this.itemKey
          // this.assignItem.parentOrgCode?this.subAssignItem.areaCode = this.assignItem.parentOrgCode:''
        }
      }else if(this.employeeLevel===50){
        this.subAssignItem.areaCode = this.assignItem.orgCode
        this.subAssignItem.srcAssignId = this.srcAssignId
        this.subAssignItem.itemKey = this.itemKey
      }
      this.$emit("handleSubmit",this.subAssignItem)
    },
    updateSubmitData(index,submitCountQty,totalCountQty,val){
      console.log(totalCountQty,val);
      let min = this.isHQ?totalCountQty:submitCountQty
      if(Number(val)<min){
        this.$alert(`配额修改结果需大于${this.isHQ?'已分配':'已提报'}数量！`, '提示', {
          confirmButtonText: '确定',
          confirmButtonClass: 'btn-red',
        }).then(() => {
          if(this.isHQ){
            this.subAssignList[index].assignQty = totalCountQty
          }else {
            this.subAssignList[index].assignQty = submitCountQty
          }
          //this.themeBasic.themeTime = val
        })
      }
      this.$emit("handleSubmitAssign",this.subAssignList,this.itemKey)
    },
    handleBlur(){
      if(this.employeeLevel>=60&&this.employeeLevel<90){
        if(this.buToCity==1){
          this.subAssignItem.areaCode = this.assignItem.orgCode
          this.subAssignItem.regionCode = this.assignItem.parentOrgCode
          this.subAssignItem.srcAssignId = this.srcAssignId
        }else {
          this.subAssignItem.regionCode = this.assignItem.orgCode
          this.subAssignItem.srcAssignId = this.srcAssignId
          // this.assignItem.parentOrgCode?this.subAssignItem.areaCode = this.assignItem.parentOrgCode:''
        }
      }else if(this.employeeLevel>=50&&this.employeeLevel<60){
        this.subAssignItem.areaCode = this.assignItem.orgCode
        this.subAssignItem.srcAssignId = this.srcAssignId
      }
      console.log(this.subAssignItem);
      this.$emit("handleAssign",this.subAssignItem)
    },
    handleSelectDate(val){
      if(val.length!==0){
        // let itemKey
        // if(this.submitAssignList.length === 0){
        //   itemKey = 1
        // }else {
        //   itemKey = this.submitAssignList[this.submitAssignList.length-1].itemKey + 1
        // }
        // let data = {
        //   assignStartTime:this.value1[0],
        //   assignEndTime:this.value1[1],
        //   itemKey,
        //   needTransitions:1,
        //   subAssignList:[]
        // }
        // console.log(4444);
        // this.submitAssignList.push(data)
        this.$emit("handleChangeAssignDate",val,this.itemKey)
        this.value1 = []
        this.ischangeDate = false
      }
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item.is-error .el-input__inner,
.el-form-item.is-error .el-input__inner:focus, 
.el-form-item.is-error .el-textarea__inner, 
.el-form-item.is-error .el-textarea__inner:focus, 
.el-message-box__input input.invalid, 
.el-message-box__input input.invalid:focus {
  border-color: #c7c7c7 !important;
}
::v-deep .el-form-item {
  margin: 3px 0;
  .el-form-item__label {
    text-align: left;
    color: black;
    font-weight: 600;
  }

  .el-form-item__content {
    line-height: 35px !important;
  }
}
::v-deep .operation-btn .el-input__inner {
    width: 250px;
}
::v-deep .el-input__inner {
  width: 155px !important;
  padding-right: 25px;
}
.bu_item{
  margin: 0 15px 0 5px;
}
::v-deep  .el-form-item {
    margin: 3px 15px 0 0px !important;
    //display: flex;
    width: 200px;
}
.warning{
  display: inline-block;
  margin-left: 10px;
  color: red;
}
.assign-box{
  display: flex;
  flex-wrap: wrap;
  margin: 5px 0;
}
.operation-btn{
  display: flex;
  height: 30px;
  text-align: center;
  align-items: center;
  width: 300px;
  justify-content: space-between;
}
.add-style{
  color: rgb(0, 145, 230);
  cursor: pointer;
}
.operate-style{
  color: rgb(238, 0, 0);
  cursor: pointer;
}
.assign-region-info{
  font-size: 12px;
  color: #cd1231;
  margin-top: 8px;
}
.config-detail-box{
  width: 100%;
}
.config-detail{
  display: flex;
  flex-wrap: wrap;
  margin: 0 20px;
  width: calc(100% - 20px);
  //justify-content: space-between;
}
.session-time{
  font-size: 16px;
  color: black;
  margin:0px 0 8px 10px;
}
.assign-number{
  margin-left: 50px;
  font-weight: 600;
  color: black;
  font-size: 16px;
}
.assign-region-title{
  width: 100%;
  font-size: 15px;
  //font-weight: 600;
  color: black;
  margin-bottom: 5px;
}
.tip{
  margin:20px 0px 0 20px;
}
.assign-item{
  margin:5px 30px 20px 0;
}
</style>